export default __webpack_public_path__ + "static/media/high-5.43293a0e.png";